import { AdminRouteName } from '../../../CONSTANTS';
import EquifaxReportsTableRecords from '../EquifaxReportsTableRecords';

const optionalColumn = [
  'createdAt',
];

const optionalColumnLabelFormat = {
  createdAt: 'Date created',
};

const AllRentCollection = () => (
  <EquifaxReportsTableRecords
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    defaultUrl={AdminRouteName.equifaxReportRoute}
    toggleStorageId="equifax_reports-table-col"
    hasNameAndImage
    permissionName="can-update-rent-payment-settlement-status"
  />
);
export default AllRentCollection;
